"use client";
import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { useSendTransacMutation } from "@/app/api/send-transac/front";
import type { Travel } from "../getTravel";

type Props = {
  travel: Travel;
};
export const Transac = ({ travel }: Props) => {
  const searchParams = useSearchParams();
  const [sendTransac] = useSendTransacMutation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    sendTransac({
      travel: {
        id: travel.id,
        title: travel.title,
        brandTitle: travel.brandTitle,
        travelTypeId: travel.travelTypeId,
        destinations: travel.destinations.map((d) => d.title),
        themes: travel.themes.map((t) => t.title),
      },
      atCampaign: searchParams.get("at_campaign"),
    });
  }, [travel.id]);

  return null;
};
